import { styled } from 'goober';

export const OptionButton = styled('button')`
  width: 100%;
  max-width: 352px;
  display: flex;
  color: #3d3d3d;
  padding: 1rem;
  font-size: 1rem;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
  align-items: center;
  margin-bottom: 0.5rem;
  border-radius: 0.5rem;
  border: 1px solid #b9cfcc;
  justify-content: space-between;
  background-color: rgba(255, 255, 255, 0.8);

  &:hover {
    background-color: #fff1d9;
  }
`;
